<div
  class="layout-topbar bg-teal-600! text-white! px-6 py-3 flex flex-row items-center"
>
  <app-confirm-dialog
    [confirmationKey]="logoutConfirmationKey"
  ></app-confirm-dialog>

  <p-dialog
    header="Selecione sua entidade"
    [visible]="entitySelectionService.displayRequiredDialog()"
    [modal]="true"
    [closable]="false"
    [draggable]="false"
    [resizable]="false"
    [dismissableMask]="false"
    [closeOnEscape]="false"
    [style]="{ width: 'min(32rem, calc(100vw - 2rem))' }"
  >
    <div class="topbar-entity-dialog">
      <p class="topbar-entity-dialog__description">
        Para continuar, selecione a entidade que deseja acessar.
      </p>

      <p-select
        inputId="required-entity-select"
        [options]="entitySelectionService.entityOptions()"
        optionLabel="label"
        optionValue="id"
        placeholder="Selecione uma entidade"
        [ngModel]="entitySelectionService.pendingEntityId()"
        (ngModelChange)="entitySelectionService.setPendingEntityId($event)"
        [ngModelOptions]="{ standalone: true }"
        [loading]="entitySelectionService.entitiesLoading()"
        [disabled]="
          entitySelectionService.entitiesLoading() ||
          !entitySelectionService.hasEntities()
        "
        appendTo="body"
        styleClass="topbar-entity-dialog__select"
        panelStyleClass="entity-select-panel"
      >
        <ng-template pTemplate="selectedItem" let-option>
          <span class="entity-select-value">{{ option.label }}</span>
        </ng-template>

        <ng-template pTemplate="item" let-option>
          <div
            class="entity-select-option"
            [class.entity-select-option--root]="option.depth === 0"
          >
            <span
              *ngIf="option.depth > 0"
              class="entity-select-option__guides"
              aria-hidden="true"
            >
              <span
                *ngFor="let guide of option.guides; let isLast = last"
                class="entity-select-option__guide"
                [class.entity-select-option__guide--branch]="isLast"
              ></span>
            </span>

            <span class="entity-select-option__label">{{ option.label }}</span>
          </div>
        </ng-template>
      </p-select>

      <button
        type="button"
        class="topbar-entity-dialog__action"
        [disabled]="!entitySelectionService.canConfirmEntitySelection()"
        (click)="entitySelectionService.confirmPendingEntitySelection()"
      >
        Continuar
      </button>
    </div>
  </p-dialog>

  <button
    #menubutton
    class="p-link layout-menu-button layout-topbar-button"
    (click)="layoutService.onMenuToggle()"
  >
    <i class="pi pi-bars text-[2em]!"></i>
  </button>

  <div class="layout-topbar-brand flex-1">
    <a class="layout-topbar-logo ml-3 d-flex align-center" routerLink="">
      <h1 class="text-white! text-2xl! p-0! m-0!">VS Agenda</h1>
    </a>
  </div>

  <app-topbar-clock class="layout-topbar-clock"></app-topbar-clock>

  <div class="layout-topbar-entity">
    <div class="layout-topbar-entity__shell">
      <i class="pi pi-building"></i>
      <p-select
        inputId="topbar-entity-select"
        [options]="entitySelectionService.entityOptions()"
        optionLabel="label"
        optionValue="id"
        [placeholder]="entitySelectionService.entityPlaceholder()"
        [ngModel]="entitySelectionService.selectedEntityId()"
        (ngModelChange)="entitySelectionService.selectEntityById($event)"
        [ngModelOptions]="{ standalone: true }"
        [loading]="entitySelectionService.entitiesLoading()"
        [disabled]="
          entitySelectionService.entitiesLoading() ||
          !entitySelectionService.hasEntities() ||
          entitySelectionService.displayRequiredDialog()
        "
        [attr.aria-label]="entitySelectionService.entityAriaLabel()"
        appendTo="body"
        styleClass="layout-topbar-entity__select"
        panelStyleClass="entity-select-panel"
      >
        <ng-template pTemplate="selectedItem" let-option>
          <span class="entity-select-value">{{ option.label }}</span>
        </ng-template>

        <ng-template pTemplate="item" let-option>
          <div
            class="entity-select-option"
            [class.entity-select-option--root]="option.depth === 0"
          >
            <span
              *ngIf="option.depth > 0"
              class="entity-select-option__guides"
              aria-hidden="true"
            >
              <span
                *ngFor="let guide of option.guides; let isLast = last"
                class="entity-select-option__guide"
                [class.entity-select-option__guide--branch]="isLast"
              ></span>
            </span>

            <span class="entity-select-option__label">{{ option.label }}</span>
          </div>
        </ng-template>
      </p-select>
    </div>
  </div>

  <app-topbar-user-menu
    class="layout-topbar-user-menu"
    [userName]="userName"
    [userEmail]="userEmail"
    (accountClick)="openMyAccount()"
    (helpClick)="openHelp()"
    (logoutClick)="logout()"
  ></app-topbar-user-menu>
</div>
